import {VehicleBase} from './vehicle-base';

export class Vehicle extends VehicleBase {
  id: number;
  options: string;
  mileage: number;
  chassisnumber: string;
  reportingCode: string;
  duplicateCode: string;
  comment: string;
}
